import { Navigate, generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { DayTripPlanEditPresenter } from "./presenter";
import { useDayTripPlanEditQuery } from "../../model/repository/existing/query/use-day-trip-plan-edit-query";

type Props = {
	hotelID: string;
	planID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const DayTripPlanEditContainer = ({ hotelID, planID, activeLangCode, navigator }: Props) => {
	const serverModel = useDayTripPlanEditQuery({ hotelID, planID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })} />;
	}

	return <DayTripPlanEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />;
};

DayTripPlanEditContainer.displayName = "DayTripPlanEditContainer";
